import React from 'react';
import styled from 'styled-components';

export interface SearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const StyledInput = styled.input`
  padding: 12px 16px;
  border-radius: 20px;
  border: none;
  background-color: #1C1628;
  color: #fff;
  font-size: 14px;
  width: 100%;
  height: 40px;
  transition: all 0.2s ease;
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1);
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
`;

const SearchInput: React.FC<SearchInputProps> = ({ 
  placeholder = 'Search...', 
  value, 
  onChange 
}) => {
  return (
    <StyledInput
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
};

export default SearchInput;
